import Icon from "@ant-design/icons";

const RetailStoreSvg = () => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill="#31493C"
      stroke="none"
    >
      <path
        d="M1446 4795 c-74 -26 -125 -81 -146 -154 -5 -20 -10 -141 -10 -269 l0
   -233 -280 -463 c-279 -462 -280 -464 -280 -520 0 -67 30 -163 72 -228 41 -66
   142 -157 216 -196 l62 -33 0 -260 0 -259 -293 0 -293 0 -33 143 c-44 192 -38
   187 -203 187 -124 0 -130 -1 -153 -25 -33 -33 -32 -70 4 -106 27 -27 35 -29
   105 -29 62 0 76 -3 80 -17 3 -10 53 -231 111 -491 l105 -472 -36 -33 c-117
   -102 -86 -281 58 -341 37 -16 37 -16 37 -75 -1 -82 31 -144 94 -185 l27 -18 0
   -157 c0 -177 10 -210 75 -237 52 -21 4148 -21 4200 0 66 28 75 58 75 254 0
   187 -9 229 -52 254 -15 8 -76 15 -178 18 l-155 5 -3 922 -2 922 62 33 c74 39
   175 130 216 196 42 65 72 161 72 228 0 57 -1 58 -290 537 l-290 480 0 221 c0
   129 -5 238 -11 261 -15 56 -92 128 -152 143 -34 9 -405 12 -1409 12 -1144 -1
   -1369 -3 -1402 -15z m2800 -169 c11 -16 14 -61 14 -203 l0 -183 -1405 0 -1405
   0 0 180 c0 179 0 181 25 206 l24 24 1366 -2 c1340 -3 1367 -3 1381 -22z
   m-2226 -553 c0 -5 -55 -189 -122 -410 l-123 -403 -412 0 c-227 0 -413 2 -413
   4 0 3 35 62 78 133 43 70 154 253 246 406 l168 277 289 0 c159 0 289 -3 289
   -7z m768 -400 l-3 -408 -417 -3 c-325 -2 -418 1 -418 10 0 7 54 189 120 405
   66 216 120 395 120 398 0 3 135 5 300 5 l300 0 -2 -407z m752 402 c0 -3 54
   -181 120 -397 66 -216 120 -398 120 -405 0 -10 -85 -13 -415 -13 l-415 0 0
   410 0 410 295 0 c162 0 295 -2 295 -5z m996 -403 c134 -222 244 -406 244 -408
   0 -2 -186 -4 -413 -4 l-412 0 -123 403 c-67 221 -122 405 -122 410 0 4 131 6
   291 5 l291 -3 244 -403z m-2796 -582 c0 -25 -46 -97 -90 -141 -172 -172 -488
   -172 -660 0 -47 47 -70 83 -84 129 l-7 22 420 0 c285 0 421 -3 421 -10z m1030
   0 c0 -25 -46 -97 -90 -141 -172 -172 -488 -172 -660 0 -44 44 -90 116 -90 141
   0 7 136 10 420 10 284 0 420 -3 420 -10z m1030 0 c0 -25 -46 -97 -90 -141
   -172 -172 -488 -172 -660 0 -44 44 -90 116 -90 141 0 7 136 10 420 10 284 0
   420 -3 420 -10z m1024 -12 c-14 -46 -37 -82 -84 -129 -172 -172 -488 -172
   -660 0 -44 44 -90 116 -90 141 0 7 136 10 421 10 l420 0 -7 -22z m-2762 -352
   c184 -88 393 -88 576 0 59 28 95 55 152 113 l75 76 75 -76 c118 -119 264 -179
   440 -179 176 0 322 60 440 179 l75 76 75 -76 c118 -120 263 -178 443 -179 l77
   0 0 -905 0 -905 -340 0 -340 0 0 575 c0 573 0 575 20 575 12 0 32 11 45 25 24
   23 25 29 25 164 0 77 -3 147 -6 156 -18 46 -3 45 -1029 45 -1026 0 -1011 1
   -1029 -45 -3 -9 -6 -79 -6 -156 0 -135 1 -141 25 -164 13 -14 33 -25 45 -25
   20 0 20 -2 20 -575 l0 -575 -88 0 -88 0 0 62 c0 94 -50 174 -133 211 -18 8
   -181 14 -530 17 -457 5 -505 7 -514 22 -8 12 -8 24 1 42 l12 26 524 0 525 0
   25 22 c22 20 34 62 101 361 41 187 75 358 75 380 0 55 -34 114 -88 152 l-44
   30 -229 3 -229 3 0 240 0 239 78 0 c179 1 324 59 442 179 l75 76 75 -76 c57
   -58 93 -85 152 -113z m1678 -531 l0 -35 -875 0 -875 0 0 35 0 35 875 0 875 0
   0 -35z m-2079 -191 c11 -13 3 -61 -51 -302 -35 -158 -65 -293 -68 -299 -3 -10
   -100 -13 -437 -13 -404 0 -434 1 -439 18 -3 9 -32 141 -66 292 -34 151 -64
   285 -67 298 l-5 22 560 0 c499 0 561 -2 573 -16z m1127 -576 l-3 -573 -352 -3
   -353 -2 0 575 0 575 355 0 355 0 -2 -572z m862 -3 l0 -575 -350 0 -350 0 0
   575 0 575 350 0 350 0 0 -575z m-2820 -465 c25 -25 25 -51 2 -80 -21 -26 -66
   -30 -89 -7 -23 23 -19 68 7 89 29 23 55 23 80 -2z m476 -45 l0 -66 -149 3
   -150 3 -1 63 -1 62 150 0 150 0 1 -65z m263 39 c12 -15 21 -32 21 -39 0 -26
   -36 -57 -65 -57 -29 0 -65 31 -65 57 0 24 41 65 65 65 14 0 32 -11 44 -26z
   m3311 -374 l0 -110 -2015 0 -2015 0 0 110 0 110 2015 0 2015 0 0 -110z"
      />
      <path
        d="M1881 4494 c-28 -35 -26 -67 3 -101 l24 -28 337 0 337 0 24 28 c29
   34 31 66 3 101 l-20 26 -344 0 -344 0 -20 -26z"
      />
      <path
        d="M3121 4494 c-28 -35 -26 -67 3 -101 l24 -28 337 0 337 0 24 28 c29
   34 31 66 3 101 l-20 26 -344 0 -344 0 -20 -26z"
      />
      <path
        d="M2383 1678 c-39 -44 -193 -323 -193 -351 0 -40 15 -63 48 -75 58 -20
   79 1 185 186 85 147 98 176 92 202 -13 59 -92 81 -132 38z"
      />
      <path
        d="M2552 1593 c-34 -30 -202 -334 -202 -365 0 -37 40 -78 75 -78 16 0
   38 11 54 28 39 39 201 327 201 357 0 59 -83 96 -128 58z"
      />
      <path
        d="M3259 1690 c-23 -13 -209 -340 -209 -366 0 -12 9 -33 21 -48 27 -35
   86 -37 116 -3 42 47 193 324 193 354 0 55 -71 92 -121 63z"
      />
      <path
        d="M3416 1588 c-31 -28 -206 -334 -206 -360 0 -28 54 -78 83 -78 40 0
   61 26 156 192 102 176 111 211 65 247 -34 27 -67 27 -98 -1z"
      />
    </g>
  </svg>
);

const RetailStoreIcon = (props) => (
  <Icon component={RetailStoreSvg} {...props} />
);

export default RetailStoreIcon;
